import { notFoundRouterRoute } from '@townsquare/404-page-view/__router-route';
import { agentsRouterRoute } from '@townsquare/agents-view/__router-route';
import { appsResource } from '@townsquare/apps-store/resource';
import { appsRoute } from '@townsquare/apps-view/__router-route';
import { popupAuthRoute } from '@townsquare/auth/popup-login';
import { capabilityProviderResource } from '@townsquare/capability-provider/resource';
import { chatRouterRoute } from '@townsquare/chat-view/__router-route';
import {
	dashboardRouterRoute,
	dashboardDirectoryRouterRoute,
	dashboardByIdRouterRoute,
} from '@townsquare/dashboards-view/__router-route';
import { dashboardResources } from '@townsquare/dashboards-view/resources';
import { discoverRoute } from '@townsquare/discover-view/route';
import {
	createKudosEmbedRouterRouteOld,
	goalEmbedRouterRoute,
	goalsDirectoryEmbedRouterRoute,
	labelEmbedRouterRoute,
	createKudosEmbedRouterRoute,
	projectEmbedRouterRoute,
	projectsDirectoryEmbedRouterRoute,
	agentEmbedRouterRoute,
} from '@townsquare/embeds/__router-route';
import { emptyOrNonProvisionedStatusUpdateStateRouterRoute } from '@townsquare/empty-or-not-provisioned-state/__router-route';
import { goalCapabilitiesResource } from '@townsquare/goal-capabilities/resource';
import {
	goalUpdateViewRouterRoute,
	projectUpdateViewRouterRoute,
	recentsViewRouterRoute,
	savedViewsUpdatesRouterRoute,
	tagFeedViewRouterRoute,
	teamUpdatesViewRouterRoute,
} from '@townsquare/home-view/routes';
import { homeTabRoute } from '@townsquare/hometab-view/__router-route';
import { notificationsRouterRoute } from '@townsquare/notifications-view/__router-route';
import { projectCapabilitiesResource } from '@townsquare/project-capabilities/resource';
import { readingModeRouterRoute } from '@townsquare/reading-mode-view/__router-route';
import { applyResourcesToRoute, expandGlobalRoute } from '@townsquare/router/create-route';
import {
	GlobalHomePageRoute,
	HomepageRouteType,
	HomepageRoutes,
} from '@townsquare/router/route-types';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';
import { rovoRouterRoute } from '@townsquare/rovo-view/__router-route';
import { rovoSearchRouterRoute } from '@townsquare/rovosearch-view/__router-route';
import { searchConfigurationResource } from '@townsquare/search-config-resource';
import { searchRouterRoute } from '@townsquare/search-view/__router-route';
import {
	noWorkspacePersonalSettingsRouterRoute,
	settingsRouterRoute,
} from '@townsquare/settings-view/__router-route';
import { starredRoute } from '@townsquare/starred-view/route';
import { tagsDirectoryRouterRoute } from '@townsquare/tags-directory-view/__router-route';
import { topicRouterRoute } from '@townsquare/topic-view/__router-route';
import { followGoalActionRouterRoute } from '@townsquare/url-actions/follow-goal/__router-route';
import { followProjectActionRouterRoute } from '@townsquare/url-actions/follow-project/__router-route';
import { lookupRedirectActionRouterRoute } from '@townsquare/url-actions/lookup-redirect/__router-route';
import { reactionUpdateActionRouterRoute } from '@townsquare/url-actions/reaction-update/__router-route';
import { searchRedirectActionRouterRoute } from '@townsquare/url-actions/search-redirect/__router-route';

// When adding a new route, please also add it to the route-sanity-check E2E test
export const routeDefinitions: HomepageRoutes = [
	// Actions
	followProjectActionRouterRoute,
	followGoalActionRouterRoute,
	lookupRedirectActionRouterRoute,
	reactionUpdateActionRouterRoute,
	searchRedirectActionRouterRoute,

	// Routes
	goalUpdateViewRouterRoute,
	chatRouterRoute,
	agentsRouterRoute,
	notificationsRouterRoute,
	projectUpdateViewRouterRoute,
	readingModeRouterRoute,
	savedViewsUpdatesRouterRoute,
	searchRouterRoute,
	rovoRouterRoute,
	rovoSearchRouterRoute,
	settingsRouterRoute,
	tagFeedViewRouterRoute,
	recentsViewRouterRoute,
	teamUpdatesViewRouterRoute,
	topicRouterRoute,
	tagsDirectoryRouterRoute,
	dashboardRouterRoute,
	dashboardByIdRouterRoute,
	dashboardDirectoryRouterRoute,
	appsRoute,
	discoverRoute,
	starredRoute,

	// Embed routes
	createKudosEmbedRouterRoute,
	createKudosEmbedRouterRouteOld,
	goalEmbedRouterRoute,
	goalsDirectoryEmbedRouterRoute,
	labelEmbedRouterRoute,
	projectEmbedRouterRoute,
	projectsDirectoryEmbedRouterRoute,
	agentEmbedRouterRoute,

	// Fallback
	homeTabRoute,
	popupAuthRoute, // TODO: Justin
	notFoundRouterRoute,
];

export const noWorkspaceRouteDefinitions: GlobalHomePageRoute[] = [
	notificationsRouterRoute,
	emptyOrNonProvisionedStatusUpdateStateRouterRoute,
	chatRouterRoute,
	agentsRouterRoute,
	searchRouterRoute,
	rovoRouterRoute,
	rovoSearchRouterRoute,
	discoverRoute,
	recentsViewRouterRoute,
	noWorkspacePersonalSettingsRouterRoute,
	appsRoute,
	starredRoute,
	agentEmbedRouterRoute,

	// Fallback
	homeTabRoute,
	notFoundRouterRoute,
];

export const routes: HomepageRouteType[] = routeDefinitions
	.flatMap<HomepageRouteType>((route) => {
		if (route.routeType === 'global') {
			return expandGlobalRoute(route);
		}

		return route;
	})
	.map((route) => {
		if (route.routeType === 'global' || route.routeType === 'site') {
			route = applyResourcesToRoute(route, [
				appsResource,
				rovoEntitlementResource,
				searchConfigurationResource,
				capabilityProviderResource,
				projectCapabilitiesResource,
				goalCapabilitiesResource,
				...dashboardResources,
			]);
		}

		return route;
	});

export const noWorkspaceRoutes: HomepageRouteType[] = noWorkspaceRouteDefinitions
	.flatMap<HomepageRouteType>((route) => {
		if (route.routeType === 'global') {
			return expandGlobalRoute(route);
		}

		return route;
	})
	.map((route) => {
		if (route.routeType === 'global' || route.routeType === 'site') {
			route = applyResourcesToRoute(route, [
				appsResource,
				rovoEntitlementResource,
				searchConfigurationResource,
				projectCapabilitiesResource,
				goalCapabilitiesResource,
			]);
		}

		return route;
	});
